import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SesionService } from 'src/app/core/service/sesion.service';
import { ContactInformation, UploadFileContactInformation } from './model/potential-customer';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';
import { DocumentId } from 'src/app/core/model/constans';
import { CustomerInformationService } from './service/customer-information.service';
import { TaxValidation } from '../tax-validation/model/tax-validation';
import { FileUploadService } from '../file-upload/service/file-upload.service';
import { TermsConditionsDialogComponent } from 'src/app/shared/dialogs/terms-conditions-dialog/terms-conditions-dialog.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('150ms', style({ opacity: 1 }))]),
      transition(':leave', [animate('150ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class ContactInformationComponent implements OnInit, OnDestroy {
  files: any[] = [];
  contactForm: FormGroup;
  submitted: boolean;
  loading: boolean;
  sumeTime: number;
  telephoneNumber: string;
  secondaryTelephoneNumber: string;
  secondaryTelephoneIncompleteFields: boolean;
  subscription: Subscription;
  timeA = {
    start: 6,
    end: 22,
  };
  minDate = new Date();
  taxValidationData: TaxValidation | null;
  src: string = 'assets/terms-and-conditions.pdf';
  @Output()
  onComplete = new EventEmitter<number>();

  @Output()
  onBack = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private sesion: SesionService,
    private dialog: MatDialog,
    public shadowScroll: ShadowScrollService,
    private serviceFile: FileUploadService,
    private service: CustomerInformationService,
  ) {
    this.submitted = false;
    this.loading = false;
    this.sumeTime = 0;
    this.telephoneNumber = '';
    this.taxValidationData = this.sesion.getItem('tax_validation');
    this.secondaryTelephoneNumber = '';
    this.secondaryTelephoneIncompleteFields = false;
    this.setFiles();
    this.contactForm = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/), Validators.maxLength(50)],
      ],
      telephoneNumber: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      secondaryTelephoneNumber: ['', Validators.pattern(/^\d{11}$/)],
      uploadFile0: [''],
      timeAStart: [''],
      timeAEnd: [''],
      conditionsAndTerms: ['', Validators.requiredTrue],
      localOpening: ['', Validators.required],
      dateOpening: ['', Validators.required],
    });

    this.subscription = this.contactForm.controls['localOpening'].valueChanges.subscribe((data) => {
      this.localIsInaugurated(data);
    });
  }

  setFiles() {
    this.files = [
      {
        label: 'Fotos comerciais',
        fileId: 'file 1',
        file: null,
        extensions: ['.png', '.jpeg', '.jpg', '.pdf'],
        size: 20,
        isImg: true,
        documentId: DocumentId.FOTO_COMERCIO,
      },
    ];
  }

  localIsInaugurated(value: string) {
    if (value === 'true') {
      this.contactForm.controls['dateOpening'].clearValidators();
      this.contactForm.controls['dateOpening'].setErrors(null);
      this.contactForm.controls['dateOpening'].setValue('');
    } else {
      this.contactForm.controls['dateOpening'].addValidators(Validators.required);
    }
  }

  ngOnInit(): void {
    this.contactForm.controls['uploadFile0'].valueChanges.subscribe(() => {
      this.serviceFile.hideSpinner();
    });
  }

  ngOnDestroy() {
    // Cancelar la suscripción
    if (this.subscription) {
      this.subscription.unsubscribe();
      console.log('Suscripción cancelada.');
    }
  }

  back() {
    this.onBack.emit();
  }

  subtractTime(time1: string, time2: string): number {
    // convertir las cadenas de texto en horas y minutos
    const [hours1, minutes1] = time1.split(':').map(Number);
    const [hours2, minutes2] = time2.split(':').map(Number);

    // calcular la diferencia en minutos
    const totalMinutes1 = hours1 * 60 + minutes1;
    const totalMinutes2 = hours2 * 60 + minutes2;
    const diffMinutes = totalMinutes1 - totalMinutes2;

    // convertir la diferencia en horas y minutos
    const hoursDiff = Math.floor(diffMinutes / 60);
    let minutesDiff = diffMinutes % 60;
    console.log('houserDif', hoursDiff);
    console.log('minutesDiff', minutesDiff);
    if (minutesDiff == 30) {
      minutesDiff = 50;
    }
    let formattedDiff = Number(hoursDiff + '.' + minutesDiff);
    return Number.isNaN(formattedDiff) ? 0 : formattedDiff;
  }

  onSubmit() {
    if (!this.loading) {
      this.submitted = true;
      let timeA = this.subtractTime(
        this.contactForm.controls['timeAEnd'].value,
        this.contactForm.controls['timeAStart'].value,
      );
      console.log('timeA', timeA);
      this.telephoneNumber = this.contactForm.controls['telephoneNumber'].value;
      if (this.contactForm.valid && timeA >= 6) {
        this.formComplete();
      }
    }
  }

  formattedNumber(number: string): string {
    if (number && number.length === 10) {
      return number.substring(0, 4) + ' ' + number.substring(4);
    }
    return number;
  }

  formComplete() {
    const ContacInformation: ContactInformation = {
      email: this.contactForm.controls['email'].value,
      telephone: this.formattedNumber(this.contactForm.controls['telephoneNumber'].value),
      secondaryTelephone: this.formattedNumber(this.contactForm.controls['secondaryTelephoneNumber'].value),
      timeAStart: this.contactForm.controls['timeAStart'].value,
      timeAEnd: this.contactForm.controls['timeAEnd'].value,
      localOpening: this.contactForm.controls['localOpening'].value,
      dateOpening: this.contactForm.controls['dateOpening'].value,
    };
    const uploadFileOptional: UploadFileContactInformation = {
      uploadFile0: this.contactForm.controls['uploadFile0'].value,
    };
    console.log('contacInfomration', JSON.stringify(ContacInformation.telephone));

    console.log('uploadFile0', uploadFileOptional.uploadFile0);
    this.sesion.setItem('contact-information', JSON.stringify(ContacInformation));
    this.service.saveFiles(uploadFileOptional);
    this.onComplete.emit(6);
  }

  validationPicker(start: any, end: any, touchOne: boolean, touchTwo: boolean) {
    if (start >= end && touchOne && touchTwo) {
      return false;
    }
    return true;
  }

  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }

  openTermsDialog() {
    const isMobile = window.innerWidth < 768;
    this.dialog.open(TermsConditionsDialogComponent, {
      height: isMobile ? '100%' : '85%',
      width: isMobile ? '100%' : '60%',
      data: {
        pdfSrc: this.src,
      },
    });
  }

  openTermsDialogOnKeyDown(event: KeyboardEvent) {
    this.openTermsDialog();
  }

  validationLenthTelephone(type: string): boolean {
    let fullnumber;
    let max;
    if (type == 'principal') {
      fullnumber = this.contactForm.controls['telephoneNumber'].value;
      max = 11;
    } else {
      fullnumber = this.contactForm.controls['secondaryTelephoneNumber'].value;
      max = 11;
    }
    return fullnumber.length != max && fullnumber != 0;
  }
}
